/* eslint-disable max-len */

import Chart from 'chart.js';
import ReduChartInterior from './reduchart-interior';
import ReduChartExterior from './reduchart-exterior';
import ReduChartLight from './reduchart-light';

export default class ReduChart {
  constructor() {
    this.customChartSettings();
    new ReduChartLight();
    new ReduChartInterior();
    new ReduChartExterior();
  }
  customChartSettings() {
    Chart.defaults.global.defaultFontFamily = 'futura-pt';
    Chart.scaleService.updateScaleDefaults('linear', {
      ticks: {
        min: 0,
      },
    });
    Chart.pluginService.register({
      beforeDraw: function (chart, easing) {
        if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
          var helpers = Chart.helpers;
          var ctx = chart.chart.ctx;
          var chartArea = chart.chartArea;

          ctx.save();
          ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
          ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
          ctx.restore();
        }
      },
    });
  }
}
